// istanbul ignore file
/* eslint-disable */
// ignore lint and test rules since this is a slightly altered ARIA SDK and will be replaced with the current third party version by Work Item 348115

import { BondDataType } from "./bond-const";
// OOO Circular: services/services-io-aria-web-telemetry/src/ariawebtelemetry/ts/lib/microsoft.bond.ts > services/services-io-aria-web-telemetry/src/ariawebtelemetry/ts/lib/microsoft.bond.io.ts
import { IStream } from "./microsoft.bond.io";
// OOO Circular: services/services-io-aria-web-telemetry/src/ariawebtelemetry/ts/lib/microsoft.bond.ts > services/services-io-aria-web-telemetry/src/ariawebtelemetry/ts/lib/microsoft.bond.encoding.ts
import {
  Utf8,
  Varint,
  Varint64,
  Double,
  Float,
  Zigzag
} from "./microsoft.bond.encoding";

export class FieldTag {
  constructor(type: BondDataType, id: number) {
    this.Type = type;
    this.Id = id;
  }

  Type: BondDataType;
  Id: number;
}

export class ContainerTag {
  constructor(elementType: BondDataType, size: number) {
    this.ElementType = elementType;
    this.Size = size;
  }

  ElementType: BondDataType;
  Size: number;
}

export class KeyValueContainerTag {
  constructor(keyType: BondDataType, valueType: BondDataType, size: number) {
    this.KeyType = keyType;
    this.ValueType = valueType;
    this.Size = size;
  }

  KeyType: BondDataType;
  ValueType: BondDataType;
  Size: number;
}

// @ts-ignore
export class Bonded<T> {}

export class Int64 {
  // BUG!!: need implement, currently, just handle 32bits number
  constructor(numberStr: string) {
    this.low = parseInt(numberStr);
    if (this.low < 0) {
      this.high = -1;
    }
  }

  Equals(numberStr: string): boolean {
    var tmp = new Int64(numberStr);
    return this.low == tmp.low && this.high == tmp.high;
  }

  low: number = 0;
  high: number = 0;
}

export class UInt64 {
  // BUG!!: need implement, currently, just handle 32bits number
  constructor(numberStr: string) {
    this.low = parseInt(numberStr);
  }

  Equals(numberStr: string): boolean {
    var tmp = new UInt64(numberStr);
    return this.low == tmp.low && this.high == tmp.high;
  }

  low: number = 0;
  high: number = 0;
}

export class Number {
  static ToByte(value: number): number {
    return this.ToUInt8(value);
  }

  static ToInt8(value: number): number {
    var signMask = ((value & 0x80) << 24) >> 24;
    return (value & 0x7f) | signMask;
  }

  static ToInt16(value: number): number {
    var signMask = ((value & 0x8000) << 16) >> 16;
    return (value & 0x7fff) | signMask;
  }

  static ToInt32(value: number): number {
    var signMask = value & 0x80000000;
    return (value & 0x7fffffff) | signMask;
  }

  static ToUInt8(value: number): number {
    return value & 0xff;
  }

  static ToUInt16(value: number): number {
    return value & 0xffff;
  }

  static ToUInt32(value: number): number {
    return value & 0xffffffff;
  }
}

export class Exception {
  constructor(message: string) {
    this.Message = message;
  }

  Message: string;
}

export class KeyValuePair<TKey, TValue> {
  Key?: TKey;
  Value?: TValue;
}

export class BrowserChecker {
  static IsDataViewSupport(): boolean {
    return typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";
  }
}

export interface IBondSerializable {
  Write(writer: IProtocolWriter): void;
  Read(reader: IProtocolReader): void;
}

/**
 * Declares the interface to be implemented by a protocol in order to
 * serialize Bond data.
 */
export interface IProtocolWriter {
  WriteBlob(blob: number[]): void;
  WriteBool(value: boolean): void;
  WriteContainerBegin(size: number, elementType: BondDataType): void;
  WriteMapContainerBegin(
    size: number,
    keyType: BondDataType,
    valueType: BondDataType
  ): void;
  WriteContainerEnd(): void;
  WriteDouble(value: number): void;
  WriteFloat(value: number): void;
  WriteFieldBegin(
    type: BondDataType,
    id: number,
    metadata: IBondSerializable | null
  ): void;
  WriteFieldEnd(): void;
  WriteFieldOmitted(
    type: BondDataType,
    id: number,
    metadata: IBondSerializable | null
  ): void;
  WriteInt16(value: number): void;
  WriteInt32(value: number): void;
  WriteInt64(value: Int64): void;
  WriteInt8(value: number): void;
  WriteString(value: string): void;
  WriteStructBegin(metadata: IBondSerializable | null, isBase: boolean): void;
  WriteStructEnd(isBase: boolean): void;
  WriteUInt16(value: number): void;
  WriteUInt32(value: number): void;
  WriteUInt64(value: UInt64): void;
  WriteUInt8(value: number): void;
  WriteWString(value: string): void;
}

export class CompactBinaryProtocolWriter implements IProtocolWriter {
  constructor(stream: IStream) {
    this._stream = stream;
  }

  /*override*/
  WriteBlob(blob: number[]): void {
    this._stream.Write(blob, 0, blob.length);
  }

  /*override*/
  WriteBool(value: boolean): void {
    this._stream.WriteByte(value ? 1 : 0);
  }

  /*override*/
  WriteContainerBegin(size: number, elementType: BondDataType): void {
    this.WriteUInt8(elementType);
    this.WriteUInt32(size);
  }

  /*override*/
  WriteMapContainerBegin(
    size: number,
    keyType: BondDataType,
    valueType: BondDataType
  ): void {
    this.WriteUInt8(keyType);
    this.WriteUInt8(valueType);
    this.WriteUInt32(size);
  }

  /*override*/
  WriteContainerEnd(): void {}

  /*override*/
  WriteDouble(value: number): void {
    var array = Double.GetBytes(value);
    this._stream.Write(array, 0, array.length);
  }

  /*override*/
  WriteFloat(value: number): void {
    var array = Float.GetBytes(value);
    this._stream.Write(array, 0, array.length);
  }

  /*override*/
  WriteFieldBegin(
    type: BondDataType,
    id: number,
    // @ts-ignore
    metadata: IBondSerializable
  ): void {
    if (id <= 5) {
      this._stream.WriteByte(type | (id << 5));
    } else if (id <= 0xff) {
      this._stream.WriteByte(type | (6 << 5));
      this._stream.WriteByte(id);
    } else {
      this._stream.WriteByte(type | (7 << 5));
      this._stream.WriteByte(id);
      this._stream.WriteByte(id >> 8);
    }
  }

  /*override*/
  WriteFieldEnd(): void {}

  /*override*/
  WriteFieldOmitted(
    // @ts-ignore
    type: BondDataType,
    // @ts-ignore
    id: number,
    // @ts-ignore
    metadata: IBondSerializable
  ): void {}

  /*override*/
  WriteInt16(value: number): void {
    value = Zigzag.EncodeZigzag16(value);
    this.WriteUInt16(value);
  }

  /*override*/
  WriteInt32(value: number): void {
    value = Zigzag.EncodeZigzag32(value);
    this.WriteUInt32(value);
  }

  /*override*/
  WriteInt64(value: Int64): void {
    this.WriteUInt64(Zigzag.EncodeZigzag64(value));
  }

  /*override*/
  WriteInt8(value: number): void {
    this._stream.WriteByte(Number.ToInt8(value));
  }

  /*override*/
  WriteString(value: string): void {
    if (value == "") {
      this.WriteUInt32(0 /*length*/);
    } else {
      var array = Utf8.GetBytes(value);
      this.WriteUInt32(array.length);
      this._stream.Write(array, 0, array.length);
    }
  }

  /*override*/
  // @ts-ignore
  WriteStructBegin(metadata: IBondSerializable, isBase: boolean): void {}

  /*override*/
  WriteStructEnd(isBase: boolean): void {
    this.WriteUInt8(isBase ? BondDataType.BT_STOP_BASE : BondDataType.BT_STOP);
  }

  /*override*/
  WriteUInt16(value: number): void {
    var array = Varint.GetBytes(Number.ToUInt16(value));
    this._stream.Write(array, 0, array.length);
  }

  /*override*/
  WriteUInt32(value: number): void {
    var array = Varint.GetBytes(Number.ToUInt32(value));
    this._stream.Write(array, 0, array.length);
  }

  /*override*/
  WriteUInt64(value: UInt64): void {
    var array = Varint64.GetBytes(value);
    this._stream.Write(array, 0, array.length);
  }

  /*override*/
  WriteUInt8(value: number): void {
    this._stream.WriteByte(Number.ToUInt8(value));
  }

  /*override*/
  WriteWString(value: string): void {
    this.WriteUInt32(value.length);
    for (var i = 0; i < value.length; ++i) {
      var charCode = value.charCodeAt(i);
      this._stream.WriteByte(charCode);
      this._stream.WriteByte(charCode >>> 8);
    }
  }

  private _stream: IStream;
}

export interface IProtocolReader {}

export class CompactBinaryProtocolReader implements IProtocolReader {}
